module.exports = __webpack_public_path__ + "img/color-5x.a26eb221.svg";